<template>
  <div class="md:mr-8 md:w-2/4 w-full mb-8 md:mb-0">
    <div class="flex items-center">
      <p>Booking Number</p>

      <BaseTooltip>
        <p>
          <b>EF students</b>
          <br />The booking number is found on your booking confirmation and
          invoice from EF. For an Academy student, the booking number is the
          student ID (usual format XXX1234567).
          <br />
          <br />
          <b>Hult students</b>
          <br />The booking number is your Student ID number and is found on
          your online account and on your Hult invoice (usual format 1234567).
          <br />
          <br />
          <b>Au Pairs</b>
          <br />The booking number is found on your invoice and on your au pair
          online account (usual format XXX1234567).
        </p>
      </BaseTooltip>
    </div>

    <p v-if="!valid && value !== ''" class="text-red-300 text-xs mt-1">
      Please only use alphanumerics, no space, /- etc
    </p>

    <input
      type="text"
      aria-label="Booking Number"
      :value="value"
      :disabled="disabled"
      :aria-invalid="!valid"
      placeholder="Booking Number"
      class="form-input w-full text-sm py-3 mt-4"
      :class="{
        'shadow-errorShadow focus:shadow-errorShadow': !valid && value !== '',
        'text-gray-500 bg-gray-200 border-gray-400 cursor-not-allowed': disabled,
        'text-gray-900': !disabled
      }"
      @input="$emit('input', $event.target.value.replace(/\s/g, ''))"
      @keydown.space.prevent
    />
  </div>
</template>

<script>
export default {
  name: 'BookingNumber',
  props: {
    value: {
      type: String,
      default: null
    },
    valid: Boolean,
    disabled: Boolean
  }
};
</script>
